import BaseService from './base.service'
import { deleteToken, deleteUserInfo } from '@/services/axios'
import store from '@/store'
const API_URL = process.env.VUE_APP_API_URL

interface LoginPayload {
    teller_id: string
    teller_pin: string
    ignore_cache?: boolean
}

interface ResetPinPayload {
    teller_pin: string
    teller_pin_new: string
    teller_pin_confirmation: string
}

class AuthService extends BaseService {
    login(payload: LoginPayload) {
        return this.post(API_URL + `api/session/login`, payload).then((response) => {
            return response.data
        })
    }
    logout() {
        deleteToken()
        deleteUserInfo()
        store.dispatch('removeUserInfo')
    }
    resetPin(payload: ResetPinPayload) {
        return this.post(API_URL + `api/auth-session/reset-pin`, payload).then((response) => {
            return response.data
        })
    }
}

export default new AuthService()
